module.exports = __webpack_public_path__ + "static/error-ig-3-98bbd48901e1cba688ab86c5cd4acdd1.png";